import { Icon } from '@iconify/react/dist/iconify.js';

interface SizeProps {
  size?: number;
}

export function GoogleDocs({ size = 20 }: SizeProps) {
  return (
    <Icon
      icon={'simple-icons:googledocs'}
      fontSize={size}
      color="#0086F9"
      className="text-[#fff]"
    />
  );
}
export function GoogleDrive({ size = 20 }: SizeProps) {
  return <Icon icon={'logos:google-drive'} fontSize={size} />;
}
export function Confluence({ size = 20 }: SizeProps) {
  return <Icon icon={'logos:confluence'} fontSize={size} />;
}
export function Notion({ size = 20 }: SizeProps) {
  return <Icon icon={'devicon:notion'} fontSize={size} />;
}
export function Figma({ size = 20 }: SizeProps) {
  return <Icon icon={'logos:figma'} fontSize={size} />;
}
export function Github({ size = 20 }: SizeProps) {
  return <Icon icon={'ri:github-fill'} color="white" fontSize={size} />;
}
export function Slack({ size = 20 }: SizeProps) {
  return <Icon icon={'logos:slack-icon'} fontSize={size} />;
}
export function Amplitude({ size = 20 }: SizeProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path
        fill="#fff"
        d="M128 0c70.683 0 128 57.317 128 128s-57.317 128-128 128S0 198.734 0 128S57.317 0 128 0m-16.912 39.12c-15.782.051-30.073 25.445-42.359 75.412c-8.687-.103-16.655-.257-24.109-.36h-1.13c-.926-.052-1.851 0-2.777.103c-4.215.77-7.248 4.472-7.248 8.739c0 4.37 3.239 8.122 7.557 8.79l.102.103H64.72a578 578 0 0 0-5.706 29.404l-.72 4.164v.205a5.84 5.84 0 0 0 2.724 4.935c2.725 1.748 6.375.926 8.123-1.799l.154.154l11.566-37.063h55.724c4.266 16.141 8.687 32.745 14.548 48.373c3.135 8.379 10.435 27.913 22.67 28.016h.154c18.917 0 26.32-30.587 31.203-50.84c1.08-4.37 1.953-8.123 2.827-10.899l.36-1.13l.052-.167c.4-1.445-.416-2.988-1.851-3.483c-1.491-.514-3.187.257-3.701 1.799l-.412 1.13c-1.593 4.473-3.084 8.637-4.42 12.39l-.103.308c-8.225 23.184-11.926 33.774-19.277 33.774h-.463c-9.407 0-18.198-38.143-21.54-52.486c-.565-2.467-1.079-4.78-1.593-6.785h60.659c1.08 0 2.159-.257 3.136-.771l.047-.039a2 2 0 0 1 .21-.115l.308-.206l.154-.103c.155-.103.309-.206.463-.36l.227-.188c1.114-.969 1.903-2.321 2.24-3.719c.772-3.65-1.644-7.248-5.294-7.967h-.309c-.36-.052-.668-.103-1.028-.103l-.925-.103c-21.436-1.542-43.49-2.16-64.206-2.57l-.051-.155c-10.024-37.783-22.62-76.388-39.582-76.388m-.669 17.015c.874 0 1.697.514 2.416 1.44c1.748 2.775 4.832 8.995 9.408 22.772c3.135 9.459 6.528 21.23 10.126 34.904c-13.673-.205-27.45-.36-40.816-.514l-6.785-.051c7.66-29.918 16.964-52.588 23.8-57.934c.566-.36 1.183-.617 1.851-.617"
      />
    </svg>
  );
}

export function OtherIcon({ size }: SizeProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 7.08329C18.3333 10.075 15.9083 12.5 12.9167 12.5C12.775 12.5 12.625 12.4916 12.4833 12.4833C12.275 9.84163 10.1583 7.72495 7.51666 7.51662C7.50832 7.37495 7.5 7.22496 7.5 7.08329C7.5 4.09163 9.925 1.66663 12.9167 1.66663C15.9083 1.66663 18.3333 4.09163 18.3333 7.08329Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5003 12.9167C12.5003 15.9083 10.0753 18.3333 7.08366 18.3333C4.09199 18.3333 1.66699 15.9083 1.66699 12.9167C1.66699 9.925 4.09199 7.5 7.08366 7.5C7.22533 7.5 7.37532 7.50832 7.51698 7.51666C10.1586 7.72499 12.2753 9.84168 12.4837 12.4833C12.492 12.625 12.5003 12.775 12.5003 12.9167Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.35 12.1834L7.08333 10.8334L7.81667 12.1834L9.16667 12.9167L7.81667 13.65L7.08333 15L6.35 13.65L5 12.9167L6.35 12.1834Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
